import styled from 'styled-components';
import { Button, Form } from 'react-bootstrap';
import { ROBOT_STATUS_DASHBOARD_TEXT_COLORS } from 'Config/colors';

export const StatusCol = styled.div`
  display: flex;
  gap: 12px;
  flex-direction: column;
  justify-content: center;
`;

export const StatusCard = styled.div`
  min-width: 100px;
  max-height: 150px;
  border: 0.5px solid white;
  border-radius: 2px;
  background-color: rgba(128, 128, 128, 0.4);
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 5px;
`;

export const StatusCardData = styled.div`
  color: ${(props) => (
      props.textColor ?? ROBOT_STATUS_DASHBOARD_TEXT_COLORS.GREEN
  )};

  font-weight: ${(props) => (
    props.isTitle ? "bold" : "normal"
    )
  };
  display: flex;
  justify-content: center;
`;

export const StyledButton = styled(Button)`
  padding: 0px;

  &:hover {
    background: white;
  }
`;

export const SelectSettingOptionDiv = styled.div`
	display: flex;
	flex-direction: column;
	width: 350px;
	max-height: 200px;
	overflow-y: auto;
	background-color: rgba(128, 128, 128, 0.4);
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
	border-radius: 8px;
	padding: 10px;
`;


export const SelectSettingDescriptionDiv = styled.div`
	display: flex;
  justify-content: center;
  color: black;
  font-size: 18px;
  margin-bottom: 10px;
`;

export const StyledRadio = styled(Form.Check)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 50px;
  gap: 10px;
  font-size: 16px;
`;

export const StyledRadioInput = styled(Form.Check.Input)`
  display: flex;
  margin-top: 5px;
  align-items: center;
`;

export const StyledRadioLabel = styled(Form.Check.Label)`
  display: flex;
  margin-top: 5px;
  color: black;
`;